import Chronometre from "@/js/Chronometre";

import { observer } from 'mobx-react-lite';
import classes from './Chrono.module.css';

import { FaRegClock } from "react-icons/fa6";

const Chrono = () => {

  let {minutes, seconds} = Chronometre.elapsedTimeObj

  return (
    <div className={classes.Chrono}>
      <FaRegClock />
      <span>{minutes.toString().padStart(2, "0")} : {seconds.toString().padStart(2, "0")}</span>
    </div>
  );
};

export default observer(Chrono);
